class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();

    // Initialize selectedVariant with the current selection if it exists
    const defaultVariantInput = this.querySelector('[name="id"]');
    if (defaultVariantInput) {
      this.selectedVariant = defaultVariantInput.value;
    }

    // Set up event delegation for handling changes and clicks
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('change', event => {
      if (event.target.name === "id") {
        this.variantChange(event.target.value);
      }
    });

    this.addEventListener('click', event => {
      if (event.target.type === "submit") {
        this.addToCart(event);
      }
    });
  }

  variantChange(newVariantId) {
    this.selectedVariant = newVariantId;
    let variantUrl = `/products/${this.dataset.handle}?view=card&variant=${this.selectedVariant}`;
    console.log(variantUrl);

    fetch(variantUrl)
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const responseCard = html.querySelector('marmeto-product-card');
        this.innerHTML = responseCard.innerHTML;
        this.setupEventListeners(); // Re-setup listeners after HTML update
      });
  }

  addToCart(event) {
    event.preventDefault();
    let formData = {
      'items': [{
        'id': this.selectedVariant,
        'quantity': 1
      }]
    };

    console.log("Adding to cart", formData);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log("Item added successfully:", data);
      // Optionally, trigger any UI updates here
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });
  }
}

customElements.define('marmeto-product-card', MarmetoProductCard);
